import { useState } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Select,
  Checkbox,
  message,
  Upload,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";

import ContentCard from "../../../components/ContentCard/ContentCard";
import DefaultCardHeader from "../../../components/DefaultCardHeader/DefaultCardHeader";
import { Categories, SubmissionStatus } from "../../../common/utils";

const { Option } = Select;

export default function CreateAmbassadorPage(props) {
  const [updating, setUpdating] = useState(false);
  const [selectedImage, setSelectedImage] = useState({
    url: "/images/default-img.svg",
    file: {},
  });

  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = async (formValues) => {
    setUpdating(true);
    const formData = new FormData();

    formData.append("fullName", formValues.fullName);
    formData.append("emailAddress", formValues.emailAddress);
    formData.append("phone", formValues.phone);
    formData.append("position", formValues.position);
    formData.append("bio", formValues.bio);
    formData.append("status", formValues.status);
    formData.append("isCurrentMember", formValues.isCurrentMember);
    formData.append("gender", formValues.gender);
    formData.append("country", formValues.country);
    formData.append("category", formValues.category);

    if (selectedImage && selectedImage?.file) {
      formData.append("image", selectedImage.file);
    }

    const response = await fetch(
      `${process.env.REACT_APP_API_MASTER}/team-application/submit`,
      {
        method: "POST",
        body: formData,
      }
    );
    const data = await response.json();

    if (data.success) {
      form.resetFields();
    } else {
      messageApi.open({
        type: "error",
        content: data.message,
      });
    }
    setUpdating(false);
  };

  const handleImageUpload = (e) => {
    if (e && e.file) {
      const { file } = e;

      const imageUrl = URL.createObjectURL(file);
      setSelectedImage({ url: imageUrl, file });
    }
  };

  const handleImageDelete = () => {
    setSelectedImage(null);
  };

  return (
    <>
      {contextHolder}
      <ContentCard
        isStickyHead
        headerContent={
          <div>
            <DefaultCardHeader>
              <div className="ambassadors-card__header">Create Ambassador</div>
            </DefaultCardHeader>
          </div>
        }
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            fullName: "",
            emailAddress: "",
            phone: "",
            position: "",
            bio: "",
            status: "",
            isCurrentMember: false,
            gender: "",
            country: [],
          }}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Full Name"
                name="fullName"
                rules={[
                  { required: true, message: "Please input your full name!" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Email Address" name="emailAddress">
                <Input type="email" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Phone" name="phone">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Position" name="position">
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Gender" name="gender">
                <Select placeholder="Select gender">
                  <Option value="Male">Male</Option>
                  <Option value="Female">Female</Option>
                  <Option value="Other">Other</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Country" name="country">
                <Select mode="multiple" placeholder="Select countries">
                  <Option value="Australia">Australia</Option>
                  <Option value="Nigeria">Nigeria</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Status" name="status">
                <Select placeholder="Select a status">
                  <Option value={SubmissionStatus.PENDING}>PENDING</Option>
                  <Option value={SubmissionStatus.REJECTED}>REJECTED</Option>
                  <Option value={SubmissionStatus.ACCEPTED}>ACCEPTED</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Category" name="category">
                <Select placeholder="Select a category">
                  <Option value={Categories.THE_BOARD_SECTION}>
                    The Board Section
                  </Option>
                  <Option value={Categories.HEADS_OF_RESEARCH}>
                    Operations
                  </Option>
                  <Option value={Categories.FIELD_RESEARCH_OFFICERS}>
                    Field Research Officers
                  </Option>
                  <Option value={Categories.ADVOCATES}>
                    Advocates
                  </Option>
                  <Option value={Categories.BRAND_AMBASSADORS}>
                    Ambassadors
                  </Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            label="Bio"
            name="bio"
            rules={[
              {
                required: true,
                message: "Please input bio!",
              },
            ]}
          >
            <Input.TextArea rows={4} />
          </Form.Item>

          <Form.Item label="Profile Image" name="image">
            <Upload
              beforeUpload={() => false}
              listType="picture"
              onChange={handleImageUpload}
            >
              <Button icon={<UploadOutlined />}>Upload Profile Image</Button>
            </Upload>
          </Form.Item>

          <Form.Item name="isCurrentMember" valuePropName="checked">
            <Checkbox>Current Member</Checkbox>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              disabled={updating}
              loading={updating}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </ContentCard>
    </>
  );
}
